export default {
  onPriceInput(value) {
    const raw = String(value).replace(/[^0-9]/g, "");
    this.form.price = Number(raw) || 0;
  },
  isPreferenceSelected(option) {
    return this.form.preferences.includes(option);
  },
  togglePreference(option, checked) {
    if (checked) {
      if (!this.form.preferences.includes(option)) {
        this.form.preferences.push(option);
      }
      this.$set(
        this.form.preferenceWeights,
        option,
        Number(this.form.preferenceWeights[option]) || 3
      );
      return;
    }

    this.form.preferences = this.form.preferences.filter(
      (preference) => preference !== option
    );
    this.$delete(this.form.preferenceWeights, option);
  },
};
